module.exports = __webpack_public_path__ + "img/horizontal_6_3_3.0105562c.png";